"use client"
import ContactForm from "../../components/ContactForm"

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 to-orange-100">
      <ContactForm />
    </div>
  )
}

//comment just to commit
